import SourceResource from 'sources/sourceTypes/Resource';
import { Resource } from 'types';

export const toSource = (_obj: Resource): SourceResource => {
  return new SourceResource();
};

export const toType = (sourceObj: SourceResource): Resource => {
  const resource = new Resource();

  resource.id = sourceObj.id;
  resource.name = sourceObj.name;

  return resource;
};
